<template>
  <b-modal
    id="cultura-manifesto-modal"
    :visible="true"
    hide-footer
    hide-header
    size="lg"
    centered
    scrollable
    @hidden="$emit('close')"
  >
    <div class="manifesto-modal">
      <!-- HEADER -->
      <header class="manifesto-header">
        <div class="header-left">
          <div class="file-icon">📄</div>
          <h3>Manifesto eSUS Feedback</h3>
        </div>

        <button type="button" class="close-btn" @click="$emit('close')">
          ✕
        </button>
      </header>

      <!-- BODY -->
      <section class="manifesto-body">
        <p>
          Na eSUS Feedback, o feedback é nossa marca registrada. Dar feedbacks
          construtivos faz parte do nosso dia a dia, e receber feedback é o que
          nos motiva a melhorar diariamente.
        </p>
        <p>
          Monitoramento e avaliação são a nossa especialidade. Realizamos essas
          atividades com excelência e, ao mesmo tempo, entendemos que também
          somos avaliados e monitorados diariamente em nossas tarefas. Essa
          postura dupla garante humildade e aprendizado constante. Somos eternos
          estudantes: nunca devemos perder a capacidade de aprender o que ainda
          não sabemos e de ensinar o que já aprendemos.
        </p>
        <p>
          Somos sempre gratos por cada feedback que recebemos, encarando-o como
          uma oportunidade de aprendizado. Procuramos responder os feedback com
          clareza e foco em soluções. Afinal, acreditamos que o feedback é a
          ponte para a excelência.
        </p>
        <p>
          Por isso, na eSUS Feedback, não apenas processamos informações, mas
          também cultivamos a aprendizagem contínua em tudo o que fazemos.
          <strong>
            Para isso mantemos a comunicação com gentileza, paciência e coragem
            sempre ativa em nossos bate papos. E lembre-se: “Uma imagem vale
            mais que 10 mil palavras” um vídeo vale mais que 10 mil imagens.
          </strong>
        </p>
      </section>

      <!-- FOOTER -->
      <footer class="manifesto-footer">
        <button type="button" class="btn-close" @click="$emit('close')">
          Fechar
        </button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'CulturaManifestoModal',
}
</script>

<style scoped>
.manifesto-modal {
  display: flex;
  flex-direction: column;
  max-height: 70vh;
}

/* HEADER */
.manifesto-header {
  padding: 10px 4px 12px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.file-icon {
  background: #dbeafe;
  color: #1d4ed8;
  border-radius: 12px;
  padding: 6px 10px;
}

.manifesto-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
}

.close-btn {
  border: none;
  border-radius: 999px;
  width: 32px;
  height: 32px;
  font-size: 16px;
  cursor: pointer;
  background: transparent;
  color: #64748b;
}

.close-btn:hover {
  background: #e2e8f0;
}

/* BODY */
.manifesto-body {
  padding: 12px 4px 8px;
  font-size: 15px;
  line-height: 1.6;
  color: #334155;
}

.manifesto-body p + p {
  margin-top: 12px;
}

/* FOOTER */
.manifesto-footer {
  padding: 10px 4px 2px;
  display: flex;
  justify-content: flex-end;
}

.btn-close {
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  background: #020617;
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;
}

.btn-close:hover {
  background: #111827;
}
</style>
